// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import FddPastRddTable from './components/fdd-past-rdd-table';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getConstraintType } from '../../common/repositories';
import getFddPastRdd from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';

class FddPastRdd extends Component {

    state = {
        constraintType: [],
        selectedConstraintType: '',
        results: null
    };

    componentDidMount = () => {

        // const query = new URLSearchParams( this.props.location.search );
        // const queryOrderNum = query.get( 'ordernum' );

        this.props.increaseCounter();
        getConstraintType( 'FDD_PAST_RDD_CONSTRAINT', 'regular' ).then( response => {

            const newArr = response.map( item => (
                {
                    id: item.id.trim(),
                    value: item.value.trim()
                }
            ) );
            this.setState( {
                constraintType: newArr
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );
        // if ( queryOrderNum ) this.handleOrderNumberChange( queryOrderNum );

    }

    // componentDidUpdate = prevProps => {

    //     if ( this.props.location.search !== prevProps.location.search ) {

    //         const query = new URLSearchParams( this.props.location.search );
    //         const queryOrderNum = query.get( 'ordernum' );

    //         this.handleOrderNumberChange( queryOrderNum );
    //         window.scrollTo( 0, 0 );

    //     }

    // }

    handleConstraintTypeChange ( val ) {

        this.setState( {
            selectedConstraintType: val
        } );
        this.props.increaseCounter();
        getFddPastRdd( val )
            .then( response => {

                this.setState( {
                    results: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    refresh () {

        this.props.increaseCounter();
        getFddPastRdd( this.state.selectedConstraintType )
            .then( response => {

                this.setState( {
                    results: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    render () {

        const {
            constraintType, selectedConstraintType, results
        } = this.state;
        // const crumbs = [{
        //     link: `/${this.props.unit.name}`,
        //     text: 'Home'
        // }, {
        //     link: '',
        //     text: 'Order Information'
        // }];

        const fddPastRdd = ( results !== null ? [...results] : [] );
        const fddPastRddResults = fddPastRdd.map( i => (
            { ...i, ...{ unitName: this.props.unit.name } } ) );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header"> FDD Past RDD </h2>
                </header>

                <main>

                    <section className="section-container">
                        <div className="atp-top-options atp-fdd-past-rdd-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-fdd-past-rdd-select"
                                    label="Constraint Type"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleConstraintTypeChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={constraintType}
                                    placeholder="Select Constraint Type"
                                    selectedValue={selectedConstraintType}
                                    showPlaceholder={true}
                                />
                                {selectedConstraintType && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}
                            </div>
                        </div>
                        { results !== null && (
                            <FddPastRddTable
                                results={fddPastRddResults}
                            />

                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

FddPastRdd.displayName = 'FddPastRdd';
FddPastRdd.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( FddPastRdd );
